import Vue from 'vue'
import 'babel-polyfill'
import 'url-search-params-polyfill'

import App from './App.vue'
import router from './router'
import './plugins/element.js'

import './assets/css/common/base.css'
import './css/common.css'
import jquery from 'jquery'

import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'

import VueLazyload from 'vue-lazyload'


//导入 axios
import axios from 'axios'

const url = window.location.host
axios.defaults.baseURL = !url.includes('192') ? 'https://' + url : 'https://www.yunshanyin.net'

// 注册swiper
Vue.use(VueAwesomeSwiper)
Vue.use(VueLazyload)


/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


// 过滤时间
Vue.filter('dateFormat', originVal => {
  const dt = new Date(originVal * 1000)

  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})
window.$ = window.jQuery = jquery
Vue.prototype.$http = axios
Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
